import { findNodeAndPos } from "@shared/unified-tiptap/util/descendant-helpers"
import type { Editor } from "@tiptap/core"
import type * as filestack from "filestack-js"

let nextUploadId = 1

/** Mints a fresh id for a placeholder image node (see image-node-extension's `uploadId` attr). */
export function nextImageUploadId(): number {
  return nextUploadId++
}

/**
 * Uploads `image` to Filestack, then finds the image node tagged with `uploadId` (if it's
 * still in the document) and swaps in the real `src`, clearing the placeholder.
 */
export function watchImageUpload(
  editor: Editor,
  client: filestack.Client,
  uploadId: number,
  image: string | File,
): void {
  client.upload(image).then((upload: { url: string }) => {
    const found = findNodeAndPos(
      editor.state.doc,
      (node) => node.type.name === "image" && node.attrs.uploadId === uploadId,
    )
    if (found === null) return // node was deleted
    editor.commands.command(({ tr }) => {
      tr.setNodeAttribute(found.pos, "src", upload.url)
      tr.setNodeAttribute(found.pos, "uploadId", null)
      tr.setMeta("addToHistory", false)
      return true
    })
  })
}
